import PropTypes from "prop-types";
import React from "react";

import { FetchOptionsContext, useFetchOptions } from "../FetchOptionsContext";

/**
 * Fetch options used by useFetch. Options will be shallow merged with any other existing context options.
 * See https://use-http.com/#/?id=options for more details.
 */

export const FetchOptions = (props) => {
  const { children, options } = props;
  const fetchOptions = useFetchOptions();

  return (
    <FetchOptionsContext.Provider value={updateOptions()}>{children}</FetchOptionsContext.Provider>
  );

  function updateOptions() {
    return {
      ...fetchOptions,
      ...options,
      headers: {
        ...fetchOptions.headers,
        ...options.headers,
      },
    };
  }
};

FetchOptions.displayName = "FetchOptions";

FetchOptions.propTypes = {
  /**
   * Content to be rendered and will use these fetch options.
   */
  children: PropTypes.node,

  /**
   * Fetch options used by useFetch. Options will be shallow merged with any other existing context options.
   * See https://use-http.com/#/?id=options for more details.
   */
  options: PropTypes.object,
};
